import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { ClientForm } from '@/modules/clients/components/ClientForm'
import { useClientMutation } from '@/modules/clients/hooks/useClientMutation'

export function ClientCreatePage() {
  const { create, isSubmitting, error } = useClientMutation()

  return (
    <div>
      <div className="flex items-center gap-3 mb-6">
        <Link to="/clients" className="text-gray-500 hover:text-gray-700">
          <ArrowLeft size={20} />
        </Link>
        <h1 className="text-2xl font-bold text-gray-900">Nuevo Cliente</h1>
      </div>
      <div className="card p-6">
        <ClientForm
          onSubmit={create}
          isSubmitting={isSubmitting}
          submitLabel="Crear Cliente"
          error={error}
        />
      </div>
    </div>
  )
}
